import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { search2 } from "../../../assets/icons";
import styles from "./Search.module.scss";
import filterIcon from "../../../assets/icons/common/filter-icon.svg";

const Search = (props:any) => {
  const {icon, onChange, filter=false, placeholder} = props;
  return (
    <div className={styles.Search}>
      <TextField
        onChange={onChange}
        placeholder={placeholder}
        variant="standard"
        color="secondary"
        fullWidth
        InputProps={
          {
            startAdornment: (
              <InputAdornment position="end">
                <img src={search2} alt="" style={{marginRight: "11px"}}/>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <img src={icon || filterIcon} alt="" />
              </InputAdornment>
            ),
          }
        }
      />
    </div>
  );
};

export default Search;
